// Mock data for Pharmacie Meyrin-Vergers website

export const pharmacyInfo = {
  name: "Pharmacie Meyrin-Vergers",
  tagline: "Votre santé, notre priorité",
  description: "Pharmacie moderne et accessible dans le quartier Vergers de Meyrin, face à l'hôpital. Personnel professionnel et conseils de qualité.",
  
  contact: {
    phone: "+41 22 987 59 17",
    email: "info@pharmacie-meyrin.ch",
    address: {
      street: "Rue des Arpenteurs",
      postal: "1217 Meyrin-Vergers",
      landmark: "Face à l'hôpital"
    }
  },

  hours: {
    weekdays: "8h00-19h00",
    saturday: "8h00-17h00",
    sunday: "Fermé"
  }
};

export const services = [
  {
    id: 1,
    title: "Retrait en Magasin",
    description: "Service de retrait rapide et pratique pour vos commandes",
    icon: "ShoppingBag",
    features: ["Commande en ligne", "Préparation rapide", "Retrait immédiat"]
  },
  {
    id: 2,
    title: "Visite Rapide",
    description: "Service optimisé pour vos besoins urgents",
    icon: "Clock",
    features: ["File d'attente prioritaire", "Conseils express", "Service rapide"]
  },
  {
    id: 3,
    title: "Accessibilité Totale",
    description: "Parking et entrée accessibles aux fauteuils roulants",
    icon: "Accessibility",
    features: ["Parking accessible", "Entrée sans marche", "Espaces adaptés"]
  },
  {
    id: 4,
    title: "Paiements Flexibles",
    description: "Cartes de crédit, débit et paiements NFC acceptés",
    icon: "CreditCard",
    features: ["Cartes de crédit", "Cartes de débit", "Paiement sans contact"]
  },
  {
    id: 5,
    title: "Conseils Personnalisés",
    description: "Notre équipe de pharmaciens vous conseille",
    icon: "Users",
    features: ["Consultation pharmacien", "Conseils médicamenteux", "Suivi personnalisé"]
  },
  {
    id: 6,
    title: "Livraison Gratuite",
    description: "Service de livraison gratuite dans la région",
    icon: "Truck",
    features: ["Livraison locale", "Service gratuit", "Rapidité garantie"]
  }
];

export const reviews = [
  {
    id: 1,
    name: "Jesse DeMaria-Kinney",
    rating: 5,
    comment: "Personnel très sympathique et professionnel ! Très bon !",
    date: "Il y a 6 ans",
    reviews: 1
  },
  {
    id: 2,
    name: "M BDV",
    rating: 5,
    comment: "Pharmacie propre nouvellement ouverte en face de l'hôpital.",
    date: "Il y a 6 ans",
    reviews: 122,
    photos: 1079,
    guide: true
  },
  {
    id: 3,
    name: "José Ferreiro",
    rating: 5,
    comment: "Pharmacie très moderne. Elle est près de l'hôpital Tour. En face de la rue aux Arpenteurs 1, il y a aussi un cabinet de pédiatre. Excellent personnel. Le quartier se construit.",
    date: "Il y a 5 ans",
    reviews: 182,
    photos: 1795,
    guide: true
  },
  {
    id: 4,
    name: "NatsuGame M",
    rating: 5,
    comment: "Top. Très poli et professionnel, informations de qualité",
    date: "Il y a 9 mois",
    reviews: 3
  },
  {
    id: 5,
    name: "Rritë Kurti",
    rating: 5,
    comment: "Satisfaction totale, accueil chaleureux et professionnalisme de haut niveau de la part de la pharmacienne et du personnel.",
    date: "Il y a 3 ans",
    reviews: 1
  },
  {
    id: 6,
    name: "Noemie Hoferer",
    rating: 5,
    comment: "La pharmacienne est très gentille et attentive.",
    date: "Il y a 1 an",
    reviews: 16,
    photos: 2,
    guide: true
  },
  {
    id: 7,
    name: "Matko Delalay",
    rating: 5,
    comment: "Un accueil chaleureux et beaucoup de conseils ! Ils répondent gentiment à nos petits tracas ! Merci beaucoup",
    date: "Il y a 4 ans",
    reviews: 15,
    guide: true
  },
  {
    id: 8,
    name: "Abra Cadabra",
    rating: 5,
    comment: "Belle découverte et merci pour le service de livraison gratuite",
    date: "Il y a 2 ans",
    reviews: 12
  },
  {
    id: 9,
    name: "Yagmur Ayten",
    rating: 5,
    comment: "Pharmacie avec une large gamme de produits. Bravo à l'équipe très attentive !",
    date: "Il y a 3 ans",
    reviews: 175,
    photos: 252,
    guide: true
  },
  {
    id: 10,
    name: "Patrick Colombo",
    rating: 5,
    comment: "L'équipe est attentive et vous donne d'excellents conseils. Merci.",
    date: "Il y a 5 ans",
    reviews: 149,
    photos: 992,
    guide: true
  },
  {
    id: 11,
    name: "Hassan Hassan",
    rating: 5,
    comment: "Très bon pharmacien professionnel qui écoute et donne de bons conseils.",
    date: "Il y a 3 ans",
    reviews: 1
  },
  {
    id: 12,
    name: "Cle C",
    rating: 5,
    comment: "Pharmacie accessible et propre, commerçants agréables.",
    date: "Il y a 5 ans",
    reviews: 42,
    guide: true
  },
  {
    id: 13,
    name: "jacqueline Colas",
    rating: 5,
    comment: "Service impeccable.",
    date: "Il y a 1 an",
    reviews: 30,
    guide: true
  },
  {
    id: 14,
    name: "Martin Van den Ouweland",
    rating: 5,
    comment: "Une pharmacie locale offrant tous les produits et services que vous attendez d'un grand détaillant. Située dans le nouveau quartier des Vergers de Meyrin, la pharmacie est accessible à pied malgré les travaux en cours. Personnel serviable et sympathique. Locaux commerciaux neufs et lumineux",
    date: "Il y a 6 ans",
    reviews: 200
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Dr. Marie Dubois",
    role: "Pharmacienne Titulaire",
    experience: "15 ans d'expérience",
    specialties: ["Médication personnalisée", "Conseils santé"],
    image: "https://images.pexels.com/photos/8657358/pexels-photo-8657358.jpeg"
  },
  {
    id: 2,
    name: "Jean-Pierre Martin",
    role: "Pharmacien Adjoint",
    experience: "8 ans d'expérience",
    specialties: ["Orthopédie", "Matériel médical"],
    image: "https://images.pexels.com/photos/8657295/pexels-photo-8657295.jpeg"
  }
];

export const pharmacyStats = [
  { number: "6+", label: "Années d'expérience", icon: "Award" },
  { number: "1000+", label: "Clients satisfaits", icon: "Users" },
  { number: "4.8/5", label: "Note moyenne", icon: "Star" },
  { number: "365j", label: "À votre service", icon: "Heart" }
];

export const accessibilityFeatures = [
  {
    title: "Parking Accessible",
    description: "Places de parking réservées aux personnes à mobilité réduite",
    icon: "Car"
  },
  {
    title: "Entrée Sans Marche",
    description: "Accès de plain-pied facilité pour tous",
    icon: "DoorOpen"
  },
  {
    title: "Espaces Larges",
    description: "Allées spacieuses pour la circulation en fauteuil roulant",
    icon: "Move"
  },
  {
    title: "Comptoir Adapté",
    description: "Hauteur de comptoir accessible à tous",
    icon: "Accessibility"
  }
];

export const paymentMethods = [
  { name: "Cartes de Crédit", icon: "CreditCard" },
  { name: "Cartes de Débit", icon: "Banknote" },
  { name: "Paiement NFC", icon: "Smartphone" },
  { name: "Paiement Sans Contact", icon: "Wifi" }
];